import { ProviderProfilePropertyList } from '@app/components'
import { useProviderProfile } from '@app/lib'
import { Box, LoadingOverlay } from '@mantine/core'
import { type FC } from 'react'

export const ContactTab: FC = () => {
  const { data: providerProfile, isFetching } = useProviderProfile()

  return (
    <Box pos='relative'>
      <LoadingOverlay radius='lg' visible={isFetching} />
      <ProviderProfilePropertyList providerProfile={providerProfile} section='contact' />
    </Box>
  )
}
